import { useEffect, useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";

export function BotonVigilar({ tipo, cod, padron, documento, nombre, testid, className = "" }) {
  const clave = JSON.stringify({ tipo, cod, padron, documento, nombre });
  const [id, setId] = useState(undefined);
  useEffect(() => {
    const leer = () => api.get("/portal/vigilancia/estado", { params: JSON.parse(clave) }).then((r) => setId(r.data.id)).catch(() => setId(null));
    leer();
    window.addEventListener("vigilancia-cambio", leer);
    return () => window.removeEventListener("vigilancia-cambio", leer);
  }, [clave]);
  const alternar = async (e) => {
    e.stopPropagation();
    try {
      if (id) {
        if (!window.confirm("¿Dejar de vigilarlo? Se borran sus novedades e historial de vigilancia.")) return;
        await api.delete(`/portal/vigilancia/${id}`); setId(null); toast.success("Dejaste de vigilarlo");
      } else {
        const r = await api.post("/portal/vigilancia", { tipo, cod, padron, documento, nombre });
        setId(r.data.id); toast.success(r.data.ya ? "Ya estaba en tu vigilancia" : "Agregado a tu vigilancia · te avisamos si cambia");
      }
      window.dispatchEvent(new Event("vigilancia-cambio"));
    } catch (x) { toast.error(formatApiErrorDetail(x?.response?.data?.detail)); window.dispatchEvent(new Event("vigilancia-cambio")); }
  };
  if (id === undefined) return null;
  return <button onClick={alternar} className={`inline-flex items-center gap-1 rounded-full border px-3 py-1 text-xs font-semibold ${id ? "bg-[#1f5f3f] text-white border-[#1f5f3f]" : "border-[#1f5f3f] text-[#1f5f3f] hover:bg-emerald-50"} ${className}`} data-testid={testid}>
    {id ? <><EyeOff className="w-3.5 h-3.5" />Vigilando · quitar</> : <><Eye className="w-3.5 h-3.5" />Vigilar</>}
  </button>;
}
